import { styled } from '@mui/material/styles';
import { Box } from "@mui/material";

import { APP_BAR_HEIGHT } from '../sticky-nav/sticky-nav.const';

export const StyledImage = styled('img')({
  display: 'block',
  margin: '0 auto',
  objectFit: 'cover',
  minHeight: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  overflow: 'hidden',
});

export const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  overflow: 'hidden',
});